import {createContext, useContext} from 'react';
import logo from '../assets/img/logo_ai.svg';

const LogoContext = createContext();

export const LogoProvider = ({children}) => {
    return (
        <LogoContext.Provider value={logo}>{children}</LogoContext.Provider>
    );
}

export const useLogo = () => useContext(LogoContext);